// extracted by mini-css-extract-plugin
export default {"cls1":"NewsInteractionBar-cls1___33626cffa88a69d3633","cls2":"NewsInteractionBar-cls2___51d385035f8ac1dbfed NewsInteractionBar-cls1___33626cffa88a69d3633"};